import { INotificationsRequestDTO, INotificationUserEmployeeDTO } from 'src/api/dtos';
import { MailboxFolderEnums, NotificationSortEnums, SortDirectionEnums } from 'src/shared/enums';
import { TranslationFunction } from 'src/shared/providers';
import { formatEmployeeInitials, formatEmployeeName } from 'src/shared/utils';

import { NotificationMessageTypeEnums } from './MessageCenter.enums';

export const formatUserEmployeeName = (userEmployee: INotificationUserEmployeeDTO) => {
  return userEmployee.employee ? formatEmployeeName(userEmployee.employee) : userEmployee.username ?? '';
};

export const formatUserEmployeeInitials = (userEmployee: INotificationUserEmployeeDTO) => {
  return userEmployee.employee ? formatEmployeeInitials(userEmployee.employee) : userEmployee.username?.[0] ?? '';
};

export const defaultNotificationsQueryParams: INotificationsRequestDTO = {
  mailboxFolder: MailboxFolderEnums.IN,
  sortBy: NotificationSortEnums.DATE,
  sortDirection: SortDirectionEnums.DESCENDING,
};

export const mapNotificationMessageTypeEnums = (type: NotificationMessageTypeEnums, t: TranslationFunction) => {
  switch (type) {
    case NotificationMessageTypeEnums.NEW:
      return t('messageCenter.newMessage');
    case NotificationMessageTypeEnums.REPLY:
      return t('messageCenter.reply');
    case NotificationMessageTypeEnums.REPLY_ALL:
      return t('messageCenter.replyToAll');
    case NotificationMessageTypeEnums.FORWARD:
      return t('messageCenter.forward');
    default:
    // No default
  }
};

export const VISIBLE_RECIPIENTS_COUNT = 4;
